
import utils from '@/components/pages/guests/mixins/utils'

export default {
    mixins: [utils],

    props: {
        model: {
            type: Object,
            default: () => {
                return {}
            },
        },

        user: {
            type: Object,
            default: () => {
                return {}
            },
        },
    },

    data() {
        return {
            guests: null,
            formKey: 'rsvp',
            search: {
                firstname: null,
                lastname: null,
            },
        }
    },

    methods: {
        findUser() {
            this.$axios.$get(`/api/v1/public/guests`, { params: { user_id: this.user.id, ...this.search } }).then((res) => {
                this.guests = res.data
            })
        },

        setGuest(guest) {
            this.guest = guest
        },

        clear() {
            this.guests = null
            this.search = {
                firstname: null,
                lastname: null,
            }
        },
    },
}
